const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const getAuthHeaders = () => {
    const token = sessionStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

//Function for Call Dummy Review Api
export const getDefaultReviewList = async (app_type) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/customer/default-review-list?app_type=${app_type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

// Function for Calling Search Google Places API
export const getSearchGooglePlaces = async (keyword) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/search-google-places`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify({ keyword }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Something went wrong');
        }

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Search Google Business Review Api
export const searchGoogleBusinessReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/google-business-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Amazon Review Api
export const searchAmazonReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/amazon-product-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search AliExpress Review Api
export const searchAliExpressReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/aliexpress-product-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Yelp Business Review Api
export const searchYelpBusinessReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/yelp-business-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search G2 Business Review Api
export const searchG2BusinessReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/g2-business-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Hotels Review Api
export const searchHotelsReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/hotels-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search App Store Review Api
export const searchAppStoreReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/app-store-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Capterra Review Api
export const searchCapterraReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/capterra-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Booking Review Api
export const searchBookingReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/booking-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Tripadvisor Review Api
export const searchTripadvisorReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/tripadvisor-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Airbnb Review Api
export const searchAirbnbReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/airbnb-room-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Bbb Review Api
export const searchBbbReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/bbb-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Etsy Review Api
export const searchEtsyReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/etsy-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search Facebook Review Api
export const searchFacebookReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/facebook-page-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

//Function for Search OpenTable Review Api
export const searchOpenTableReview = async (payload) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/opentable-review-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

// Function for Calling Submit Review API
export const submitReview = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/submit-review`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Call Google Review Template Api 
export const reviewTemplateList = async (app_type) => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/customer/review-template-list?app_type=${app_type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};

// Function for Calling Update Review API
export const updateReview = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-review`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

// Function for Calling Get Single Review Template Detail API
export const getSingleReviewTemplateDetail = async (id) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/single-review-template-detail?template_id=${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers,
            }
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Calling Update Review Widget Name API
export const updateReviewTemplateName = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-review-widget-name`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};



//Function for Calling Delete Review Template API
export const deleteReviewTemplate = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/delete-review-template`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};